var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4C9.89543 4 9 4.89543 9 6V8C9 8.34182 9.08575 8.6636 9.23691 8.94503L6.02005 14.0001C6.01337 14 6.00669 14 6 14H4C2.89543 14 2 14.8954 2 16V18C2 19.1046 2.89543 20 4 20H6C7.10457 20 8 19.1046 8 18V16C8 15.4512 7.77893 14.954 7.42098 14.5926L10.4015 9.90891C10.5905 9.9681 10.7915 10 11 10H13C13.2085 10 13.4095 9.9681 13.5985 9.90891L16.579 14.5926C16.2211 14.954 16 15.4512 16 16V18C16 19.1046 16.8954 20 18 20H20C21.1046 20 22 19.1046 22 18V16C22 14.8954 21.1046 14 20 14H18C17.9933 14 17.9866 14 17.98 14.0001L14.7631 8.94503C14.9143 8.6636 15 8.34182 15 8V6C15 4.89543 14.1046 4 13 4H11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorner);
export default __webpack_public_path__ + "static/media/corner.f9fdcb404f38ba7b308f93fd79ba2623.svg";
export { ForwardRef as ReactComponent };